// dataLayer events for the Content Prompt Builder, the builder's twin of
// src/client/lib/gtm-events.ts: { event: "promptbuilder-<suffix>", ...params, ts }.
// Each suffix needs a matching GTM trigger and tag (Phase 8) or it fires into the void.
// Never put free text the visitor typed (brand, audience, email) in params.

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

export type PromptBuilderEvent =
  | "view"
  | "input_changed"
  | "prompt_built"
  | "prompt_copied"
  | "gate_opened"
  // The sGTM Lead tag. params: lead_email_type, email_hash. Never the address itself.
  | "lead";

export function pushPbEvent(
  suffix: PromptBuilderEvent,
  params: Record<string, unknown> = {},
): void {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({ event: `promptbuilder-${suffix}`, ...params, ts: Date.now() });
}

/** SHA-256 hex of the trimmed, lowercased email: the form Meta and Google match on. */
export async function sha256EmailHex(email: string): Promise<string | null> {
  try {
    if (!globalThis.crypto?.subtle) return null;
    const bytes = new TextEncoder().encode(email.trim().toLowerCase());
    const digest = await crypto.subtle.digest("SHA-256", bytes);
    return Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, "0")).join("");
  } catch {
    return null;
  }
}
